import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidTagIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m21.1 10.7-8.4-8.4c-.2-.2-.4-.3-.7-.3H3c-.6 0-1 .4-1 1v9c0 .3.1.5.3.7l8.4 8.4c1.2 1.2 3.1 1.2 4.2 0l6.2-6.2c1.2-1.1 1.2-3 0-4.2Z"/>
  </SvgIcon>
}

export default SolidTagIcon
